import { render } from "./Challenges.vue?vue&type=template&id=1d287376&scoped=true"
import script from "./Challenges.vue?vue&type=script&lang=js"
export * from "./Challenges.vue?vue&type=script&lang=js"

import "./Challenges.vue?vue&type=style&index=0&id=1d287376&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d287376"]])

export default __exports__